export default {
  name: 'radius',
  type: 'detail',
  active: false,
  data: {
    active: false,
    tl: '8',
    tr: '8',
    bl: '8',
    br: '8'
  }
}
